import React, { useEffect, useState } from "react";
import ActivityFormWizard from "@/components/student/ActivityFormWizard";
import { GetBusinessPlanAPI } from "@/services/api/business/getBusinessPlan";
import { store } from "@/services/store";

/**
 * Business portal create-activity page. The wizard is shared with the student
 * pages, so the subscription pre-disable lives here: only a business session
 * whose plan is `locked` gets the wizard's submit disabled (with the reason
 * shown up-front). Students and admins never fetch a plan.
 */
const BusinessCreateActivityPage: React.FC = () => {
  const [subscriptionLocked, setSubscriptionLocked] = useState(false);

  useEffect(() => {
    if (store.getState().auth?.user_auth !== "business") return;
    let cancelled = false;
    const load = async () => {
      const resp = await GetBusinessPlanAPI();
      if (cancelled) return;
      if (resp?.status === 0 && resp.result?.access_status === "locked") {
        setSubscriptionLocked(true);
      }
    };
    load();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <ActivityFormWizard
      mode="create"
      basePath="/portal/activities"
      subscriptionLocked={subscriptionLocked}
    />
  );
};

export default BusinessCreateActivityPage;
